<template>
  <div>
    <Breadcrumb msg1="收费管理" msg2="退费管理" />
    <el-card>
      <el-row :gutter="10" style="margin-bottom: 10px">
        <el-col :span="5"><el-input v-model="query.refund_no" placeholder="退费单号" clearable></el-input></el-col>
        <el-col :span="4">
          <el-select v-model="query.status" placeholder="状态" clearable>
            <el-option label="待审批" value="待审批"></el-option>
            <el-option label="已退款" value="已退款"></el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
          <el-button type="success" icon="el-icon-plus" @click="add">新建退费</el-button>
        </el-col>
      </el-row>
      <el-table :data="list" border>
        <el-table-column label="ID" prop="id" width="60"></el-table-column>
        <el-table-column label="退费单号" prop="refundNo" width="150"></el-table-column>
        <el-table-column label="原收费单" prop="chargeId" width="100"></el-table-column>
        <el-table-column label="金额" prop="amount" width="100"></el-table-column>
        <el-table-column label="退款方式" prop="payMethod" width="110"></el-table-column>
        <el-table-column label="原因" prop="reason" show-overflow-tooltip></el-table-column>
        <el-table-column label="状态" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === '已退款' ? 'success' : 'warning'">{{ scope.row.status }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="时间" prop="refundTime" width="160"></el-table-column>
        <el-table-column label="操作" width="120">
          <template slot-scope="scope">
            <el-button size="mini" type="success" v-if="scope.row.status === '待审批'" @click="approve(scope.row.id)">审批退款</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination style="margin-top: 10px" :current-page="query.page" :page-sizes="[10, 20, 50]" :page-size="query.limit" layout="total, sizes, prev, pager, next, jumper" :total="total" @size-change="sizeChange" @current-change="pageChange"></el-pagination>
    </el-card>

    <el-dialog title="新建退费" :visible.sync="show" width="500px" :close-on-click-modal="false">
      <el-form :model="form" label-width="100px">
        <el-form-item label="原收费单" required>
          <el-input v-model.number="form.charge_id" placeholder="收费单ID"></el-input>
        </el-form-item>
        <el-form-item label="退费金额" required><el-input v-model.number="form.amount" type="number"></el-input></el-form-item>
        <el-form-item label="退款方式">
          <el-select v-model="form.pay_method" style="width: 100%">
            <el-option label="现金" value="现金"></el-option>
            <el-option label="微信" value="微信"></el-option>
            <el-option label="支付宝" value="支付宝"></el-option>
            <el-option label="银行卡" value="银行卡"></el-option>
            <el-option label="储值退回" value="储值"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="退费原因"><el-input v-model="form.reason" type="textarea"></el-input></el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="show = false">取消</el-button>
        <el-button type="primary" @click="save">提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb'
export default {
  components: { Breadcrumb },
  data () {
    return {
      query: { page: 1, limit: 10, refund_no: '', status: '' },
      list: [],
      total: 0,
      show: false,
      form: { charge_id: null, amount: 0, reason: '', pay_method: '现金' }
    }
  },
  created () { this.getData() },
  methods: {
    getData () {
      this.$axios.get('/refunds', res => {
        this.list = res.data.records || []
        this.total = parseInt(res.data.total) || 0
      }, this.query)
    },
    search () { this.query.page = 1; this.getData() },
    sizeChange (s) { this.query.limit = s; this.getData() },
    pageChange (p) { this.query.page = p; this.getData() },
    add () {
      this.form = { charge_id: null, amount: 0, reason: '', pay_method: '现金' }
      this.show = true
    },
    save () {
      if (!this.form.charge_id) { this.$message.warning('请填写原收费单ID'); return }
      this.$axios.post('/refunds', () => { this.show = false; this.getData() }, this.form)
    },
    approve (id) {
      this.$axios.put(`/refunds/${id}/approve`, () => this.getData())
    }
  }
}
</script>
